export class PaymentDetails {
  public referenceNumber: string;
  public date: Date;
  public description: string;
  public amount: number;

  public senderName: string;
  public senderAccount: string;

  public receiverName: string;
  public receiverAccount: string;
  public departmentCode: string;
}
